<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Brand</th>
            <th>Status</th>
            <th>Links</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="brand in affiliateCompany.associatedBrands" :key="brand.id">
            <td>
              <router-link :to="'/advertisers/brand/' + brand.id" >{{ brand.brand }}</router-link>
            </td>
            <td>{{ brand.status}}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      associatedBrands: []
    }
  },
  computed: {
    ...mapGetters({
      affiliateCompany: 'getAffiliateCompany'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompany/Tabs/BrandList.vue